import React, {
    RefObject,
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react";
import { Soundfont } from "smplr";
import { NOTES, transposeNote } from "../eb-chant/note-utils";
import "./Player.css";

const w: any = window;

var AudioContext =
    w.AudioContext || // Default
    w.webkitAudioContext; // Safari and old versions of Chrome

const NOTE_LENGTH = 0.5;

let playingId = 0;

const playTone = (
    ac: AudioContext,
    clef: "c" | "f",
    clefOffset: 5 | 7,
    score: string[],
    onFinished: () => void,
    onSetHighlightCount: (count: number) => void,
    transposedBy: number,
    playingIdRef: RefObject<number>
) => {
    const offset = clef === "c" ? 9 - clefOffset : 5 - clefOffset;

    playingId++;
    const thisPlayingId = playingId;

    let t = 0.5;

    const flute = new Soundfont(new AudioContext(), { instrument: "flute" });

    let highlightCount = 0;
    const addHighlight = (noteIndex: number) => {
        setTimeout(() => {
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
                highlightCount++;

                onSetHighlightCount(highlightCount);
            } else {
                onSetHighlightCount(0);
            }
        }, t * 1000);
    };

    const scheduleNote = (
        note: string,
        scheduleTime: number,
        long: boolean
    ) => {
        setTimeout(() => {
            if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
                console.log(transposeNote(note, transposedBy), ac.currentTime, {
                    duration: long ? NOTE_LENGTH * 2.1 : NOTE_LENGTH * 1.1,
                });

                flute.start({
                    note: transposeNote(note, transposedBy),
                    duration: long ? NOTE_LENGTH * 2.1 : NOTE_LENGTH * 1.1,
                });
            } else {
                onFinished();
            }
        }, scheduleTime * 1000);
    };

    score.forEach((note, noteIndex) => {
        if (note === "6b" || note === "4b") {
            scheduleNote("Bb3", t, false);

            addHighlight(noteIndex);

            t += NOTE_LENGTH;
        } else if (note === ",") {
            t += NOTE_LENGTH;
        } else if (note.length === 2 && note.charAt(1) === ".") {
            const noteOffset = parseInt(note.charAt(0));

            scheduleNote(NOTES[offset + noteOffset], t, true);

            addHighlight(noteIndex);

            t += NOTE_LENGTH * 2;
        } else {
            const noteOffset = parseInt(note);

            scheduleNote(NOTES[offset + noteOffset], t, false);

            addHighlight(noteIndex);

            t += NOTE_LENGTH;
        }
    });

    setTimeout(() => {
        if ((playingIdRef.current ?? 9999) <= thisPlayingId) {
            onFinished();
            onSetHighlightCount(0);
        }
    }, t * 1000);

    return playingId;
};

export const PlayButton: React.FC<{
    clef: "c5" | "c7" | "f5";
    score: string[];
    title: string;
    transposeBy: number;
    onSetHighlightCount?: (count: number) => void;
}> = (props) => {
    const { clef, score, title, transposeBy, onSetHighlightCount } = props;

    const [playing, setPlaying] = useState(false);
    const playingIdRef = useRef<number>(0);

    useEffect(() => {}, []);

    const play = useCallback(() => {
        setPlaying(true);

        const ac = new AudioContext();
        // create empty buffer
        var buffer = ac.createBuffer(1, 1, 22050);
        var source = ac.createBufferSource();
        source.buffer = buffer;
        // connect to output (your speakers)
        source.connect(ac.destination);
        // play the file
        source.start(0);
        playingIdRef.current = playTone(
            ac,
            clef === "f5" ? "f" : "c",
            clef === "c7" ? 7 : 5,
            score,
            () => {
                setPlaying(false);
            },
            onSetHighlightCount ?? ((count: number) => undefined),
            transposeBy,
            playingIdRef
        );
    }, [clef, score, transposeBy, onSetHighlightCount]);

    const stop = useCallback(() => {
        playingIdRef.current++;
    }, []);

    return (
        <div style={{ paddingLeft: 4 }}>
            <div
                className={playing ? "new-button-playing" : "new-button"}
                onClick={playing ? stop : play}
            >
                <div className="play-icon">&#9658;</div>
                <div>{title}</div>
            </div>
        </div>
    );
};
